import { pct } from '../format';
import type { GameStatus, Role, Stars } from '../types';

const EMOJI: Record<Role, string> = { t: '🟩', d: '🟨', b: '💥' };

/** Текст для «Поделиться» — вирусный механизм, формат менять только осознанно (AGENTS.md, раздел 7). */
export function shareText(input: {
  title: string;
  status: GameStatus;
  heat: number;
  stars: Stars;
  roles: readonly Role[];
}): string {
  const line = input.roles.map((r) => EMOJI[r]).join('');
  const verdict =
    input.status === 'win'
      ? `${'★'.repeat(input.stars)}${'☆'.repeat(3 - input.stars)} · 💣 ${pct(input.heat)}`
      : '💥 бомба взорвалась';
  return `Телепат · ${input.title}\n${verdict}\n${line}`;
}
